{
  "name": "utax-delivery",
  "version": "1.0.2",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build-dev": "ng build --configuration development",
    "build-prod": "ng build --configuration production && npm run sentry:sourcemaps",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org megakit --project utax-delivery ./dist/browser && sentry-cli --url https://sentry.megakit.pro/ sourcemaps upload --org megakit --project utax-delivery ./dist/browser"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.0.0",
    "@angular/cdk": "^18.0.4",
    "@angular/common": "^18.0.0",
    "@angular/compiler": "^18.0.0",
    "@angular/core": "^18.0.0",
    "@angular/forms": "^18.0.0",
    "@angular/material": "^18.0.4",
    "@angular/platform-browser": "^18.0.0",
    "@angular/platform-browser-dynamic": "^18.0.0",
    "@angular/router": "^18.0.0",
    "@ng-matero/extensions": "^18.0.1",
    "@ngx-translate/core": "^15.0.0",
    "@sentry/angular": "^8.55.0",
    "@sentry/cli": "^2.45.0",
    "body-scroll-lock-upgrade": "^1.1.0",
    "leaflet": "^1.9.4",
    "leaflet-routing-machine": "^3.2.12",
    "moment": "^2.30.1",
    "ngx-device-detector": "^8.0.0",
    "ngx-translate-multi-http-loader": "^18.0.0",
    "pako": "^2.1.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.0.5",
    "@angular/cli": "^18.0.5",
    "@angular/compiler-cli": "^18.0.0",
    "@types/jasmine": "~5.1.0",
    "@types/leaflet": "^1.9.12",
    "@types/leaflet-routing-machine": "^3.2.8",
    "@types/node": "^22.2.0",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.4.2"
  }
}
